import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ExternalLink, ArrowRight } from 'lucide-react';
import { customerStories } from '../mock';

const CustomerStories = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section ref={ref} className="py-32 bg-slate-900 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_50%,rgba(59,130,246,0.05),transparent_50%)]" />
      
      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-20"
        >
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Cerita <span className="bg-gradient-to-r from-emerald-400 to-blue-400 bg-clip-text text-transparent">Sukses</span> Pelanggan
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto">
            Lihat bagaimana perusahaan terkemuka di Indonesia menggunakan WhaTap untuk transformasi digital mereka
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {customerStories.map((story, index) => (
              <motion.div
                key={story.id}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
                whileHover={{ y: -10 }}
                className="group relative"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/5 to-blue-500/5 rounded-3xl blur-xl group-hover:blur-2xl transition-all duration-500" />
                
                <div className="relative bg-slate-950/50 backdrop-blur-sm border border-slate-800 rounded-3xl overflow-hidden h-full transition-all duration-500 group-hover:border-emerald-500/50">
                  {/* Image with overlay */}
                  <div className="relative h-64 overflow-hidden">
                    <motion.img
                      whileHover={{ scale: 1.1 }}
                      transition={{ duration: 0.6 }}
                      src={story.image}
                      alt={story.company}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/50 to-transparent" />
                    
                    {/* Company name overlay */}
                    <div className="absolute bottom-4 left-6">
                      <div className="text-emerald-400 font-semibold text-sm mb-1">STUDI KASUS</div>
                      <div className="text-white font-bold text-xl">{story.company}</div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-8">
                    <h3 className="text-2xl font-bold text-white mb-4 leading-tight group-hover:text-emerald-400 transition-colors">
                      {story.title}
                    </h3>
                    <p className="text-slate-400 mb-6 leading-relaxed">
                      {story.description}
                    </p>

                    {/* Results */}
                    <div className="space-y-2 mb-6">
                      {story.results.map((result, idx) => (
                        <div key={idx} className="flex items-center gap-2 text-slate-300">
                          <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full" />
                          <span className="text-sm">{result}</span>
                        </div>
                      ))}
                    </div>

                    {/* Read more link */}
                    <motion.button
                      whileHover={{ gap: 12 }}
                      className="flex items-center gap-2 text-emerald-400 font-semibold group/btn"
                    >
                      Baca Selengkapnya
                      <ArrowRight className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
                    </motion.button>
                  </div>
                </div>
              </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CustomerStories;
